export default __webpack_public_path__ + "static/media/ContourTurningImg.f3be7123.jpg";